import React, { useState } from "react";
import { Skeleton, Tooltip } from "antd";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./styles.scss";
import { FaCheckCircle } from "react-icons/fa";
import ESGLogoIcon from '../../../../assets/images/ESG-Chat-logo-icon.svg'
import ESGUserIcon from '../../../../assets/images/ESG-Chat-User-Icon.svg'

const QuestionText = ({ text }) => {
    const renderTextWithNewlines = (text) => {
        return text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    return <div>{renderTextWithNewlines(text)}</div>;
};

const ConversationChat = ({ chat, chatIndex }) => {
    const [copyText, setCopyText] = useState(false)

    const handleCopyText = () => {
        setCopyText(true)
        const containerText = document.getElementById(`answer-contents-${chatIndex}`)?.innerText || ""
        navigator.clipboard.writeText(containerText)

        setTimeout(() => {
            setCopyText(false)
        }, 2000)
    }

    return (
        <div className={`chat-item-wrapper ${chat?.type}-container`}>
            {(chat.type === "question") && (
                <div className="question-section">
                    <div className="icon-section">
                        <img className="icons esg-user" src={ESGUserIcon} alt="ESG icon" />
                    </div>
                    <div className="chat-item">
                        <div className="quetsion">
                            <QuestionText text={chat?.text} />
                        </div>
                    </div>
                    <Tooltip placement="top" title={!copyText ? "Click to copy" : <div className="copied-section"><FaCheckCircle style={{ marginBottom: "-2px" }} /> Copied</div>}>
                        <span className="copy-icon" onClick={() => handleCopyText()}><FontAwesomeIcon icon={faCopy} /></span>
                    </Tooltip>
                </div>
            )}
            {/* Non-Question Section */}
            {(chat.type !== "question") && (
                <div className="non-question-section">
                    {chat.type === "loading" && (
                        <div className="chat-item">
                            <Skeleton className="loader-skeleton" active paragraph={{ rows: 1 }} />
                        </div>
                    )}
                    {chat.type === "answer" && (
                        <>
                            <Tooltip placement="top" title={!copyText ? "Click to copy" : <div className="copied-section"><FaCheckCircle style={{ marginBottom: "-2px" }} /> Copied</div>}>
                                <span className="copy-icon" onClick={() => handleCopyText(chat.text)}><FontAwesomeIcon icon={faCopy} /></span>
                            </Tooltip>
                            <div className="chat-item" id={`answer-contents-${chatIndex}`} dangerouslySetInnerHTML={{ __html: chat?.text || "Answer not found in the document!" }} />
                        </>
                    )}
                    {chat.type === "error" && (
                        <div className="chat-item">{chat.text}</div>
                    )}
                    <div className="icon-section">
                        <img className="icons esg-logo" src={ESGLogoIcon} alt="ESG user icon" />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ConversationChat